import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetProfessionalCategoriesList } from "../Responses/GetProfessionalCategoriesList";

export async function getProfessionalCategoriesList(data) {
	let response = await getAPIResponse("/v1/professionalCategory-list", data);
	if (response === null) {
		return null;
	}
	let getProfessionalCategoriesList = GetProfessionalCategoriesList.createFromResponseData(response);
	return getProfessionalCategoriesList;
}